import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-507b42f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "b_line",
  style: {"margin-bottom":"18px"}
}, null, -1))
const _hoisted_4 = { class: "formRole" }
const _hoisted_5 = { class: "formdata" }
const _hoisted_6 = { class: "formitem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin":"5px"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 角色名称： ")
], -1))
const _hoisted_8 = { class: "formitem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","margin":"5px"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 角色说明： ")
], -1))
const _hoisted_10 = { class: "formitemTree" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_Tree" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin":"5px"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 菜单权限： ")
], -1))
const _hoisted_12 = { class: "treeForm" }
const _hoisted_13 = { class: "checkForm" }
const _hoisted_14 = { class: "subBtn" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Moduletitle = _resolveComponent("Moduletitle")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Moduletitle, {
        title: _ctx.title,
        img: _ctx.img,
        radius: true,
        text: _ctx.M_title
      }, null, 8, ["title", "img", "text"]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.roleName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.roleName) = $event)),
                placeholder: "请输入名称，可按职位命名（限制输入6字符内）",
                maxlength: "6"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.roleInfo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.roleInfo) = $event)),
                placeholder: "非必填项（限制输入50字符内）",
                maxlength: "50"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createVNode(_component_el_tree, {
                  ref: "treeRef",
                  data: _ctx.dataTree,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-checked-keys": _ctx.treeListIds,
                  "default-expand-all": true,
                  onCheckChange: _ctx.getCheckedNodes,
                  props: _ctx.defaultProps
                }, null, 8, ["data", "default-checked-keys", "onCheckChange", "props"]), [
                  [_directive_loading, _ctx.treeLoading]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelFn())),
              class: "cancelBtn"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitFn())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}